import config from "@/config"
import http from "@/utils/request"

export default {
	
    LoginIn: {
        url: `${config.API_URL}/System/SystemUsers/UserLogin`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
    UserRegister: {
        url: `${config.API_URL}/System/User/UserRegister`,
        name: "",
        post: async function (params) {
            return await http.post(this.url, params);
        }
    },
}